module.exports = __webpack_public_path__ + "static/21-04-02_13-11-16_4930-bf46bc2d8f8f42b41a532cc2d47e1129.png";